import { useTeamInfo } from 'src/hooks';
import {
  useAppDispatch,
  toggleWelcomeModal,
  useAppSelector,
  modalsControlState,
  setWelcomeUpsellModalType,
} from 'src/store';
import { batch } from 'react-redux';
import { WelcomeTierModal } from 'src/components/WelcomeTierModal';

export const WelcomeModal = () => {
  const dispatch = useAppDispatch();
  const { isOwner, isTeamInfoLoading, isTeamInfoFetching, teamInfo } =
    useTeamInfo();

  const { isVisibleWelcomeModal, welcomeUpsellModalType } =
    useAppSelector(modalsControlState);

  const handleCloseModal = () => {
    batch(() => {
      dispatch(toggleWelcomeModal(false));
      dispatch(setWelcomeUpsellModalType(null));
    });
  };

  if (
    !!welcomeUpsellModalType &&
    welcomeUpsellModalType.includes('business') &&
    !teamInfo
  ) {
    return null;
  }

  if (
    !welcomeUpsellModalType ||
    isOwner ||
    isTeamInfoLoading ||
    isTeamInfoFetching
  ) {
    return null;
  }

  return (
    <WelcomeTierModal
      modalType={welcomeUpsellModalType}
      isOpen={isVisibleWelcomeModal}
      onClose={handleCloseModal}
    />
  );
};
